/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionOrderPrintedLabelInfo } from '../../models/production-order-printed-label-info';

export interface GetPrintedLabelInfo$Params {
  productionOrderId: number;
}

export function getPrintedLabelInfo(http: HttpClient, rootUrl: string, params: GetPrintedLabelInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductionOrderPrintedLabelInfo>> {
  const rb = new RequestBuilder(rootUrl, getPrintedLabelInfo.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductionOrderPrintedLabelInfo>;
    })
  );
}

getPrintedLabelInfo.PATH = '/api/v1/DocumentManagement/{productionOrderId}/GetPrintedLabelInfo';
